var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('nav',{staticClass:"to-rigth"},[_c('ul',[_c('li',{staticClass:"list"},[_c('a',{staticClass:"fa fa2 fa-facebook",attrs:{"href":"https://www.facebook.com/merengonbavaro91/","target":"_blank"}})]),_c('li',{staticClass:"list"},[_c('a',{staticClass:"fa fa-instagram",attrs:{"href":"https://www.instagram.com/merengonbavaro","target":"_blank"}})])])])
}]

export { render, staticRenderFns }